var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sortable-list"},_vm._l((_vm.$slots.default),function(child,index){return _c('SortableListItem',{key:child.data.key,attrs:{"first":index === 0,"last":index === _vm.$slots.default.length - 1},on:{"remove":function () { return _vm.removeItem(child.data.key); },"reorder":function (ref) {
	var dir = ref.dir;

	return _vm.reorderItem(child.data.key, dir);
}}},[_c('Vnode',{attrs:{"node":child}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }